import httpHelper from 'helpers/httpHelper';
import {isEmpty} from 'lodash';
import toaster from '../helpers/uiHelper';

export class SubscriptionRequest {
  customerId = '';
  paymentMethodId = '';
  priceId = '';
}

export class UpdateCardRequest {
  customerId = '';
  paymentMethodId = '';
}

export class UpdatePlanRequest {
  NewPlan = '';
}

export const createSubscription = async (req: SubscriptionRequest) => {
  try {
    let response = await httpHelper.post('/subscribe', req, {acceptableErrorCodes: [500]});

    if (!response || isEmpty(response)) {
      toaster.showError('Could not create subscription');
      return undefined;
    }

    return {paymentMethodId: req.paymentMethodId, priceId: req.priceId, subscription: response};
  } catch (err) {
    let errMessage = httpHelper.getErrorMessage(err);
    if (errMessage) console.log(errMessage);

    return undefined;
  }
};

export const updateCard = async (req: UpdateCardRequest) => {
  try {
    await httpHelper.post('/subscriptions/update_card', req, {acceptableErrorCodes: [500]});
    return true;
  } catch (err) {
    let errMessage = httpHelper.getErrorMessage(err);
    if (errMessage) console.log(errMessage);

    return undefined;
  }
};

export const closeAccount = async () => {
  try {
    await httpHelper.delete('/users', {acceptableErrorCodes: [500]});
    return true;
  } catch (err) {
    let errMessage = httpHelper.getErrorMessage(err);
    console.log(errMessage);

    return undefined;
  }
};

export const updatePlan = async (req: UpdatePlanRequest) => {
  try {
    await httpHelper.post('/subscriptions/update', req, {acceptableErrorCodes: [500]});
    return true;
  } catch (err) {
    let errMessage = httpHelper.getErrorMessage(err);
    if (errMessage) console.log(errMessage);

    return undefined;
  }
};
